import { Captcha } from '@eventbrite/eds-captcha';
import { Field } from 'formik';
import React from 'react';
import { loadReCaptcha, ReCaptcha } from 'react-recaptcha-v3';
import { CAPTCHA_RETRY_RATE } from '../../../constants/captcha';
import { FORM_FIELD_COMPLETE_TO_PROCEED } from '../../../constants/loginMessages';
import { ICaptchaProps } from '../../../contexts/ConfigContext/interfaces';

const CaptchaField = ({
    showCaptcha,
    captcha,
    captchaV2Required,
    handleCaptchaV2,
    handleCaptchaV3,
    enableCaptchaV3,
    setEnableCaptchaV3,
}: {
    showCaptcha: boolean;
    captchaV2Required?: boolean;
    captcha: ICaptchaProps;
    handleCaptchaV2: (captchaToken: string) => void;
    handleCaptchaV3: (captchaToken: string) => void;
    setEnableCaptchaV3: (value: boolean) => void;
    enableCaptchaV3: boolean;
}) => {
    let handleCaptchaV3Timeout: any;

    React.useEffect(() => {
        if (captcha && !captcha.disableRecaptcha3) {
            loadReCaptcha(captcha.recaptcha3PublicKey);
        }

        // Cleanup on unmount
        return () => {
            if (handleCaptchaV3Timeout) {
                clearTimeout(handleCaptchaV3Timeout);
                // eslint-disable-next-line react-hooks/exhaustive-deps
                handleCaptchaV3Timeout = null;
            }
        };
    }, [captcha]);

    const _handleCaptchaV3 = (captchaToken: string) => {
        handleCaptchaV3(captchaToken);

        // The recaptcha token expires after two minutes
        handleCaptchaV3Timeout = setTimeout(() => {
            setEnableCaptchaV3(true);
        }, CAPTCHA_RETRY_RATE);
    };

    return (
        <div data-testid="login-captcha-field">
            {showCaptcha && captcha.recaptcha2PublicKey && (
                <div className="eds-l-pad-top-2 eds-l-mar-left-2">
                    <Field
                        name="captcha"
                        label="captcha"
                        hideLabel={true}
                        required={true}
                        component={Captcha}
                        sitekey={captcha.recaptcha2PublicKey}
                        onChange={handleCaptchaV2}
                    />
                    {captchaV2Required && (
                        <div className="eds-text-color--error">
                            {FORM_FIELD_COMPLETE_TO_PROCEED}
                        </div>
                    )}
                </div>
            )}
            {enableCaptchaV3 &&
                !captcha.disableRecaptcha3 &&
                captcha.recaptcha3PublicKey && (
                    <ReCaptcha
                        sitekey={captcha.recaptcha3PublicKey}
                        action="login"
                        verifyCallback={_handleCaptchaV3}
                    />
                )}
        </div>
    );
};

export default CaptchaField;
